export { initializeLocales, setLocale, t, useI18n } from './i18n'
